/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import './router/hooks';
import './scss/global.scss';

// import '@/libraries/bugsnag'

import Vue from 'vue';

import { router } from './router';
import { store } from './vuex';

import { i18n } from "@/plugins/vue-i18n";
import vuetify from '@/plugins/vuetify';

import '@/libraries/serviceWorker';

import '@/filters/date';
import '@/filters/mdi-icon';
import '@/filters/string';

const {
    NODE_ENV: environment,
} = process.env;

Vue.config.devtools = (environment !== 'production');
Vue.config.performance = false;
Vue.config.productionTip = (environment !== 'production');
Vue.config.silent = (environment === 'production');

import App from '@/App.vue';

new Vue({
    i18n,
    render: (createElement) => createElement(App),
    router,
    store,
    vuetify,
}).$mount('#app')
